"use client";

import { CheckCircle2, ChevronRight } from "lucide-react";
import Image from "next/image";
import styles from "./WebsiteBuilderSection.module.css";

export default function WebsiteBuilderSection() {
  return (
    <section className={styles.builder} id="website-builder">
      <div className={`${styles.container} container`}>
        <div className={styles.wrapper}>
          {/* Left Content */}
          <div className={styles.content}>
            <div className={styles.tag}>
              <span className="badge badge-blue">Website Builder & CMS</span>
            </div>
            
            <h2 className={styles.title}>
              Build Your Hotel Website <br />
              Your Way
            </h2>
            
            <p className={styles.description}>
              Create a stunning, mobile-friendly website for your hotel in minutes. Customize every section and connect your own domain.
            </p>

            <div className={styles.listGrid}>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>Custom Pages & Layouts</span>
              </div>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>SEO Friendly</span>
              </div>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>Gallery & Room Pages</span>
              </div>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>Mobile Optimized</span>
              </div>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>Blog & Offers</span>
              </div>
              <div className={styles.listItem}>
                <CheckCircle2 size={16} className={styles.checkIcon} />
                <span>Connect Your Domain</span>
              </div>
            </div>

            <a href="#demo" className={styles.btnBuilder}>
              Explore Website Builder
            </a>
          </div>

          {/* Right Visuals */}
          <div className={styles.visual}>
            <Image 
              src="/images/website-builder.png" 
              alt="Moteligo Website Builder and CMS" 
              width={800} 
              height={900} 
              className={styles.mockupImage} 
            />
          </div>
        </div>
      </div>
    </section>
  );
}
